import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTiktokStyle0 = gravityIconIndividualCss;

const GravityIconTiktok = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '6ddd4214593cb409689256dd3242171167443053', color: this.color, size: this.size }, h("svg", { key: 'ab0265cf8849309f815fbd2c9fcbde91f548c699', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'dcfb00b942b44927fc2970d0d03e953cdc9a4690', d: "M17.175 10.219a5.755 5.755 0 0 1-3.385-1.093v4.975a4.56 4.56 0 0 1-.8 2.579 4.489 4.489 0 0 1-2.112 1.658 4.442 4.442 0 0 1-2.672.148 4.476 4.476 0 0 1-2.28-1.415 4.562 4.562 0 0 1-.561-5.126 4.502 4.502 0 0 1 1.919-1.883 4.445 4.445 0 0 1 2.639-.445v2.503a2.04 2.04 0 0 0-1.27.011 2.06 2.06 0 0 0-1.02.761 2.091 2.091 0 0 0 .014 2.438 2.04 2.04 0 0 0 2.3.745 2.06 2.06 0 0 0 1.025-.755 2.09 2.09 0 0 0 .391-1.219V4.375h2.427c-.002.207.015.413.051.617a3.396 3.396 0 0 0 1.487 2.233c.548.366 1.19.561 1.847.561v2.433Z", fill: "currentColor" }))));
    }
};
GravityIconTiktok.style = GravityIconTiktokStyle0;

export { GravityIconTiktok as gravity_icon_tiktok };

//# sourceMappingURL=gravity-icon-tiktok.entry.js.map